export default __webpack_public_path__ + "assets/mp3/13279a81457724c2df997e64a2ae4ee0.mp3";